<!--
  账单示例
  lovi 2020-02-21
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('onlinePay.billingExample')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />

    <div class="scroll-wrapper">
      <scroll>
        <div class="sample">
          <h3>{{ $t("onlinePay.billingExample") }}</h3>
          <img class="samplePic" :src="httpUrl + samplePic" />
        </div>

        <div class="sample">
          <h3>{{ $t("onlinePay.serviceAssistance") }}</h3>
          <p>{{ $t("onlinePay.billingExampleTips") }}</p>
        </div>

        <div class="upload-wrap">
          <!-- 添加图片列表 -->
          <template v-if="imgList.length">
            <div
              class="item-list"
              v-for="(item, index) in imgList"
              :key="index"
            >
              <div class="img-wrap">
                <img :src="item.show" />
                <i class="icon-delete" @click="deleteImg(index)"></i>
              </div>
            </div>
          </template>

          <!-- 添加图片 -->
          <div class="item-list" v-if="imgList.length < 3">
            <van-uploader :after-read="onRead">
              <van-icon name="plus" />
            </van-uploader>
          </div>
        </div>

        <div class="button-wrap">
          <van-button
            block
            type="primary"
            :loading="btnLoading"
            @click="_uploadimages"
          >
            {{ $t("common.submit") }}
          </van-button>
        </div>
      </scroll>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sampleFlag: {
      //显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    },
    samplePic: {
      //默认图片
      type: String,
      default: function() {
        return "";
      }
    },
    imgList: {
      //上传图片列表
      type: Array,
      default: function() {
        return [];
      }
    },
    imgId: {
      //上传图片ID
      type: String,
      default: function() {
        return "";
      }
    }
  },
  components: {},
  data() {
    return {
      btnLoading: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回
      this.$emit("update:sampleFlag", false);
    },
    onRead(file) {
      // 添加图片
      let vm = this;
      let obj = {};
      obj.show = file.content;
      obj.base64 = file.content.split("base64,")[1];
      vm.imgList.push(obj);
      console.log("onRead", vm.imgList);
    },
    deleteImg(index) {
      // 删除当前图片
      let vm = this;
      vm.imgList.splice(index, 1);
      console.log("deleteImg", vm.imgList, index);
    },
    _uploadimages() {
      // 提交反馈
      let vm = this;
      let params = {};
      params.images = vm.imgList;
      params.class = 4;
      // params.encryption = 1;
      vm.btnLoading = true;
      vm.$post("/app/file/pubUploadImages", params, { alert: true }).then(
        res => {
          console.log("pubUploadImages", res);
          vm.btnLoading = false;
          vm.$toast(res.msg);
          if (res.code == 0) {
            vm.navBarBack();
            vm.$emit("update:imgList", vm.imgList);
            let idList = [];
            let list = res.data.list;
            for (let i = 0; i < list.length; i++) {
              idList.push(list[i].id);
            }
            let imgId = idList.toString();
            vm.$emit("update:imgId", imgId);
          }
        }
      );
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.sample {
  margin: 15px;
  h3 {
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: 400;
  }
  p {
    font-size: 12px;
  }
  .samplePic {
    width: 100%;
  }
}

.upload-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 15px 15px;
  .item-list {
    margin-right: 12px;
    .van-icon-plus {
      width: 38px;
      height: 38px;
      text-align: center;
      line-height: 38px;
      font-size: 16px;
      color: #d7d7d7;
      border: 1.1px solid #d7d7d7;
    }
    .img-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      height: 40px;
      width: 40px;
      border: 1.1px solid #d7d7d7;
      .icon-delete {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
        background: url("~@/assets/images/public/icon-delete.png") no-repeat
          center;
        background-size: 100% 100%;
      }
      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>
